var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 7,
    scrollbar: {
        el: '.gallery-thumbs .swiper-scrollbar',
        draggable: true,
    },
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    observer: true,
    observeParents: true,
    breakpoints: {
        1200: {
            slidesPerView:7,
            spaceBetween: 10,
        },
        0:{
            slidesPerView:3.5,
            spaceBetween: 8,
        }
    },
});

var galleryTop = new Swiper('.gallery-top', {
    autoplay : false,        
    autoHeight: false,
    effect:'fade',
    fadeEffect: { 
        crossFade: true 
    },
    navigation: {
        nextEl: ".gallery-top .swiper-button-next",
        prevEl: ".gallery-top .swiper-button-prev"
    },
    spaceBetween: 0,
    thumbs: {
        swiper: galleryThumbs,
    },
    breakpoints: {
        990: {
        },
        0:{
        }
    },
    observer: true,
    observeParents: true,
});

document.addEventListener('shopify:section:load', autoPlayVideos);
document.addEventListener('DOMContentLoaded', autoPlayVideos);

function autoPlayVideos() {
    const deferredMedias = document.querySelectorAll('deferred-media');

    deferredMedias.forEach(media => {
    const poster = media.querySelector('[id^="Deferred-Poster-"]');
    const template = media.querySelector('template');

        if (media.querySelector('video')) return;

        if (poster && template) {
            const content = template.content.firstElementChild.cloneNode(true);
            media.appendChild(content);

            const video = media.querySelector('video');
            if (video) {
            video.muted = true;
            video.autoplay = true;
            video.playsInline = true;
            video.loop = true;
            
            video.removeAttribute('controls');
            video.setAttribute('tabindex', '-1');
            video.style.pointerEvents = 'none';

            video.play().catch(() => {});
            }
        }
    });
}


if($('.product__info-container').length > 0){      
    var originPrice = $(this).find('.org_price').attr('rel');
    var rate = $(this).find('.real_price').attr('rel');
    var savePrice = Math.floor(100-(rate*100/originPrice));         
    $(this).find('.badge--set strong b').text(savePrice);

    if(Number($(this).find('.real_price').attr('rel')) > 100){
        $(this).find('.thumb_set_badge_wrap').append('<div class="thumb_badge_free"><span>FREE<strong>SHIPPING</strong></span></div>')
    }
}

/* product detail */
if($('#MainContent variant-selects').length > 0){
    $('#MainContent').append('<ul class="option_image displaynone"></ul>');

    $('#MainContent .product-form__input--pill input[type=radio]+label').each(function(){
        const label_idx = $(this).index('.product-form__input--pill input[type=radio]+label') + 1;
        const thumb_img = $('#MainContent .gallery-top .swiper-slide:nth-last-of-type(-n+'+label_idx+')').find('img').attr('src');
        $('#MainContent .option_image').prepend('<li><img src="'+thumb_img+'"></li>')
    })
    setTimeout(function(){    
        if($('#MainContent .product__title h1').attr('rel')){            
            const label_leng = $('#MainContent .product-form__input input[type=radio]+label').length;
            $('#MainContent .gallery-top .swiper-slide:nth-last-of-type(-n+'+label_leng+'), #MainContent .gallery-thumbs .swiper-slide:nth-last-of-type(-n+'+label_leng+')').remove();
        }
    },500)
}

/* product modal  */
$('quick-add-modal').each(function () {
  const $modal = $(this);

  if (!$modal.find('.option_image_modal').length) {
    $modal.append('<ul class="option_image_modal displaynone"></ul>');
  }

  const $labels = $modal.find('.product-form__input--pill input[type=radio] + label');

  $labels.each(function (idx) {
    const label_idx_modal = idx + 1;

    const thumb_img_modal = $modal
      .find('.gallery-top .swiper-slide:nth-last-of-type(-n+' + label_idx_modal + ') img')
      .attr('src');

    if (thumb_img_modal) {
      $modal.find('.option_image_modal')
        .prepend('<li><img src="' + thumb_img_modal + '"></li>');
    }
  });

  setTimeout(function () {
    $modal.find('.gallery-top .swiper-slide:nth-last-of-type(-n+' + $labels.length + ')').remove();
    $modal.find('.gallery-thumbs .swiper-slide:nth-last-of-type(-n+' + $labels.length + ')').remove();
  }, 500);
});



if($('.product-form__submit i.product_price span').length > 0){
    if($('variant-radios').length > 0){      
        var originPrice = $('.product-form__input input[type=radio]+label:last-of-type strong').attr('cp');
        var rate = $('.product-form__input input[type=radio]+label:last-of-type strong').attr('data');
        var savePrice = Math.floor(100-(rate*100/originPrice));   
        $('.gallery-top .sale_bd').text('SAVE ' + savePrice + '%');
    }else{      
        var originPrice = $('.product-form__submit i.product_price span').attr('rel');
        var rate = $('.product-form__submit i.product_price strong').attr('rel');
        var savePrice = Math.floor(100-(rate*100/originPrice));   
        $('.gallery-top .sale_bd').text('SAVE ' + savePrice + '%');
    }
}
